// extracted by mini-css-extract-plugin
export default {"scrollSection":"MotorPage_scrollSection__4j58H"};